import React from 'react';
import Link from '../Link/Link';
import dateHelper from '../../util/dateHelper';
import ZolaLogo from '../ZolaLogo';

const StoreLinks = () => {
  const year = dateHelper.getFullYear();
  return (
    <div className="common-footer__social-and-terms store-links">
      <ZolaLogo id="zola-store-logo" className="zola-store-logo zola-store-logo-rebrand" />
      <div className="store-footer-links__cols-container">
        <ul className="store-footer-links left-col">
          <li>
            <Link href="/wedding-registry/couple-reviews" subtle>
              Zola Reviews
            </Link>
          </li>
          <li>
            <Link href="https://help.zola.com/hc" target="_blank" rel="noopener noreferrer" subtle>
              FAQs
            </Link>
          </li>
          <li>
            <Link href="/order-status" subtle>
              Track Order
            </Link>
          </li>
        </ul>
        <ul className="store-footer-links right-col">
          <li>
            <Link href="/order-status" subtle>
              Start A Return
            </Link>
          </li>
          <li>
            <Link href="/returns" subtle>
              Return Policy
            </Link>
          </li>
          <li>
            <Link href="/contact-us" subtle>
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
      <ul className="store-footer-links">
        <li>
          <Link href="/wedding-registry/couple-reviews" subtle>
            Zola Reviews
          </Link>
        </li>
        <li>
          <Link href="https://help.zola.com/hc" target="_blank" rel="noopener noreferrer" subtle>
            FAQs
          </Link>
        </li>
        <li>
          <Link href="/order-status" subtle>
            Track Order
          </Link>
        </li>
        <li>
          <Link href="/order-status" subtle>
            Start A Return
          </Link>
        </li>
        <li>
          <Link href="/returns" subtle>
            Return Policy
          </Link>
        </li>
        <li>
          <Link href="/contact-us" subtle>
            Contact Us
          </Link>
        </li>
      </ul>
      <div className="copyright">
        &copy; <span className="date">{year}</span> Zola, Inc. All rights reserved.
      </div>
      <ul className="terms-links store-footer">
        <li>
          <Link href="/privacy" target="_blank" rel="noopener noreferrer" subtle>
            Privacy Policy
          </Link>
        </li>
        <li>
          <Link href="/terms" target="_blank" rel="noopener noreferrer" subtle>
            Terms of Use
          </Link>
        </li>
        <li>
          <Link href="/webaccessibility" target="_self" subtle>
            Web Accessibility
          </Link>
        </li>
        <li>
          <Link href="/privacy#CA-privacy-rights" target="_blank" rel="noopener noreferrer" subtle>
            Your CA Privacy Rights
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default StoreLinks;
